import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const MESSAGES = {
  default: "Hola%2C%20quiero%20cotizar%20una%20base%20de%20datos",
  "/datos-para-ia": "Necesitas%20saber%20informaci%C3%B3n%20de%20los%20datos%20masivos",
};

export default function FloatingWhatsapp() {
  const [show, setShow] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const { pathname } = useLocation();
  const WA = `https://wa.me/56936400479?text=${MESSAGES[pathname] || MESSAGES.default}`;

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 400);
    const collapse = setTimeout(() => setExpanded(false), 6000);
    return () => {
      clearTimeout(t);
      clearTimeout(collapse);
    };
  }, []);

  if (!show) return null;

  return (
    <a
      href={WA}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={TESTIDS.floatingWhatsapp}
      onMouseEnter={() => setExpanded(true)}
      className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold pl-4 pr-5 py-3.5 rounded-full whatsapp-pulse transition-all hover:-translate-y-0.5"
      aria-label="Cotizar por WhatsApp"
    >
      <MessageCircle size={22} className="shrink-0" />
      <span
        className={`overflow-hidden whitespace-nowrap transition-all duration-500 ${
          expanded ? "max-w-[280px] opacity-100" : "max-w-0 opacity-0"
        }`}
      >
        <span className="block text-[10px] font-mono uppercase tracking-widest opacity-90 leading-tight">
          Cotiza ahora
        </span>
        <span className="block text-[14px] font-bold leading-tight">
          WhatsApp +56 9 3640 0479
        </span>
      </span>
    </a>
  );
}
